<template>
  <section>
    <h1>{{ adminText('workflowsAll.modules_04e9462', 'Modules') }}</h1>
    <p class="page-description">
      {{ adminText('workflowsAll.once_a_ticket_for_the_event_is_sold_or_someon_64eb4db', 'Once a ticket for the event is sold or someone registers, changes to the module will no longer be possible. Additionally, modifying the module will permanently delete certain settings, and this action cannot be undone.') }}
    </p>
    <spinner v-if="loading" />
    <div v-else>
      <event-extra-modules
        :initial-values="form"
        :disable-editing="disableEditing"
        :vat-obligor="vatObligor"
        @update="handleUpdate"
      />
    </div>
    <simple-snackbar :open.sync="snackbar.open" :message-prop="workflowLabel(snackbar.messageProp)" :color="snackbar.color" />
  </section>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_EXTRA_MODULES, UPDATE_EVENT_EXTRA_MODULES } from '@/graphql/event.graphql'
import EventExtraModules from '@/components/events/event-extra-modules.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'event-extra-modules-container',
  components: { SimpleSnackbar, EventExtraModules },
  props: {
    organizationSlug: String,
    eventId: String,
  },
  data() {
    return {
      form: {
        modules: {},
        VATPercentage: null,
      },
      loading: true,
      disableEditing: false,
      vatObligor: false,
      snackbar: { open: false, color: 'primary', messageProp: '' },
    }
  },
  async mounted() {
    await this.fetchEventExtraModules()
  },
  methods: {
    async fetchEventExtraModules() {
      const {
        data: {
          getEvent: { extraModules, VATPercentage, organization },
          eventHasPendingOrAllowedAttendees,
        },
        errors,
      } = await this.$apollo.query({
        query: GET_EVENT_EXTRA_MODULES,
        variables: {
          id: this.eventId,
        },
      })
      if (errors || !extraModules) {
        return
      }
      this.loading = false
      this.form.modules = {
        ...extraModules,
        ticketPersonalization: !!extraModules.ticketPersonalization,
      }
      this.form.VATPercentage = VATPercentage != null ? Number(VATPercentage) : null
      this.vatObligor = !!(organization && organization.VATObligor)
      this.disableEditing = eventHasPendingOrAllowedAttendees
    },
    async handleUpdate() {
      const { __typename, ...extraModulesInput } = this.form.modules
      const { errors } = await this.$apollo.mutate({
        mutation: UPDATE_EVENT_EXTRA_MODULES,
        variables: {
          eventId: this.eventId,
          extraModulesInput,
          VATPercentage: this.vatObligor ? this.form.VATPercentage : null,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'workflowsAll.cannot_update_modules_abecf88',
          color: 'error',
        }

        return
      }

      this.$router.go()
    },
  },
}
</script>

<style scoped>
section {
  max-width: 42.75rem;
}

h1 {
  color: #ff4c00;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.page-description {
  margin-top: 1rem;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 800px) {
  h1 {
    display: none;
  }
}
</style>
